import React, { useState, useEffect, useContext } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import RadiologyDialog from './Dialogs/RadiologyDialog';
import ReportCard from './ReportCard';
import { useSelector, useDispatch } from 'react-redux';
import { getPatientReports } from '../../redux/Reports/ReportsAction';
import emptyRadiology from '../../assets/images/empty-radiology.svg';
import add from '../../assets/images/add.png';
import MessagesContext from '../../contexts/messagesContext';
import useCheckMobileScreen from '../../hooks/useWidth';
import { useHistory, useParams } from 'react-router';
import LanguageContext from '../../contexts/languageContext';
import WithPatientFileHeader from '../PatientFileHeader/WithPatientFileHeader';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Reports/ReportsType';
import useCheckAccess from '../../hooks/useCheckAccess';

const styles = makeStyles((theme) => ({
    item: {
        position: 'relative',
        paddingBottom: '12px'
    },
    reportCards: {
        direction: 'rtl',
        // height: '75vh',
        // height: '100vh',
        // // padding: "24px 15px",
        // overflowX: 'visible',
        // overflowY: 'auto',
        // position: "sticky",
        // top:"0",
        [theme.breakpoints.down(1025)]: {
            height: '100%',
            borderLeft: 'unset',
            overflowY: 'unset',
            background: '#f5f6fa !important'
        }
    },
    newReport: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '14px 0',
        borderRadius: '6px',
        width: '100%',
        background: 'transparent',
        fontFamily: 'mainFont',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: 1.69,
        color: '#509ffa',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f6fbff'
        },
        direction: 'rtl',
        border: '1px dashed #509ffa',
        '& img': {
            margin: '0 6px'
        },
        '&:disabled': {
            opacity: '0.5',
            cursor: 'not-allowed'
        }
    }
}));

const ReportList = () => {
    const history = useHistory();
    const params = useParams();
    const isMobile = useCheckMobileScreen();
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const radiologyArray = useSelector((state) => state.reports?.reports);
    const patientId = useSelector((state) => state.patient?.patient?.profile?.id);
    const loadingSelector = createLoadingSelector(type.GET_PATIENT_REPORTS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMode, setDialogMode] = useState('');
    const dispatch = useDispatch();
    const { notEditClinical } = useCheckAccess();
    const path = `/${params.clinicId}/patient/${params?.id}/radiology/form`;

    useEffect(() => {
        if (patientId) {
            dispatch(getPatientReports(patientId));
        }
    }, [patientId]);

    const openDialog = (mode) => {
        setDialogMode(mode);
        setDialogOpen(true);
    };
    const handleClose = () => {
        setDialogOpen(false);
    };
    const handleNewReport = () => {
        if (isMobile) {
            history.push(path);
        } else {
            openDialog('edit');
        }
        dispatch({ type: 'CANCEL_CHANGE' });
    };
    const NewReportCard = () => (
        <button onClick={handleNewReport} className={classes.newReport} disabled={notEditClinical}>
            <img src={add} style={{ height: '24px', width: '24px' }} />

            {messages.addNewReport}
        </button>
    );

    return (
        <>
            <div className={classes.item}>
                {isLoading ? (
                    <div className="loadingContainer">
                        <CircularProgress />
                    </div>
                ) : !isLoading && radiologyArray?.length ? (
                    <div className={classes.reportCards}>
                        <NewReportCard />
                        {radiologyArray?.map((i) => (
                            <ReportCard key={i.id} card={i} notEditClinical={notEditClinical} />
                        ))}
                    </div>
                ) : !isLoading && !radiologyArray?.length ? (
                    <div className={classes.reportCards}>
                        <NewReportCard />
                        <div style={{ textAlign: 'center', marginTop: '25vh' }}>
                            <div>
                                <img src={emptyRadiology} />
                            </div>
                            <div style={{ fontSize: '16px', color: '#bbbbbb', marginTop: '20px' }}>
                                <p>{messages.noReport}</p>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
            {!notEditClinical && (
                <RadiologyDialog
                    dialogMode={dialogMode}
                    openDialog={dialogOpen}
                    handleClose={handleClose}
                />
            )}
        </>
    );
};

export default WithPatientFileHeader(ReportList, ['sidebar', 'radiology']);
